import React, { useState } from "react";
import { Accordion, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { useSelector } from "react-redux";
import AccordionBody from 'react-bootstrap/AccordionBody'


const SubMenu = ({ icon, title, items, disabled, onClick, expand, appSlug }) => {

  const [collapsed, setCollapsed] = useState(true);
  const activeMainItem = useSelector(state => state.auth.mainItem);
  const slug = useSelector(state => state.auth.sideBar);
  const toggleNavbar = () => {
    if (!disabled)
      setCollapsed(!collapsed);
  };

  const handleToggleAndClick = (event) => {
    toggleNavbar();
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <Nav.Item className={classNames({ open: !collapsed })}>
      <Accordion activeKey={!disabled && activeMainItem && (expand === "false" || (slug!==null && appSlug===slug)) ? "0" : undefined} className="custom-accordion-button"
      >
        <Accordion.Item eventKey="0">
        <Accordion.Button
          as={Nav.Link}
          variant="link"
          eventKey="0"
          onClick={handleToggleAndClick}
          disabled={disabled}
        >
          {icon ? (
            <>
              <FontAwesomeIcon icon={icon} className="mr-2" />
                {title}
                {expand !== "false" && (
                <FontAwesomeIcon
                  icon={collapsed ? faCaretDown : faCaretUp}
                  className="float-right"
                />
              )}
            </>
          ):(
            <>
                {title}
              <FontAwesomeIcon
                icon={collapsed ? faCaretDown : faCaretUp}
                className="float-right"
              />
            </>
          )}
        </Accordion.Button>

        <AccordionBody eventKey="0">
          <nav className="nav flex-column">
            {items.map(item => (
              <a
                className={`nav-link nav-item pl-5 ${
                  item === "Active" ? "active" : ""
                } `}
                href
                key={item}
              >
                {item}
              </a>
            ))}
          </nav>
        </AccordionBody>
        </Accordion.Item>
       
      </Accordion>

    </Nav.Item>
  );
};

export default SubMenu;